import {connect} from "react-redux";
import RejectDealerLeadActivity from "./Reject";
import {bindActionCreators} from "redux";
import {rejectActivity} from "../../../../../service/Activity/action";
import {viewActivity} from "../../../../../service/Activity/action";
import {markAttendancesDealerLead} from "../../../../../service/Dealer/action";
import {documentUploadUrlPublic} from "../../../../../service/fileUpload/action";

const mapStateToProps = (state) => ({
    rejectActivityDetails:state.Activity.rejectActivity,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    activityByIdDetails:state.Activity.activityByIdDetails,
    markAttendanceDetails:state.Dealer.markAttendance,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            documentUploadUrlPublic,
            rejectActivity,
            viewActivity,
            markAttendancesDealerLead
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(RejectDealerLeadActivity);
